/*
 Created by qing on 2021/1/23
 Des: 实时数据
 */
import BaseItem from "../BaseItem"
import {
  DATA_TYPE__NUMBER,
  DEFAULT_VALUE__CUSTOM,
  DEFAULT_VALUE__FORMULA,
  DEFAULT_VALUE__RELATE_DATA,
  FORM_ITEM__NUMBER, FORM_ITEM__REALTIME_DATA
} from '../types'
import {defaultValueInit} from "../utils"

class RealTimeData extends BaseItem {

  constructor() {
    super()


    this.showUnit = '' // 单位
    // 值
    this.value = 0
    this.defaultValue = defaultValueInit(DEFAULT_VALUE__RELATE_DATA)
  }

  get title() {
    return this.fieldTitle || RealTimeData._title
  }

  set title(val) {
    this.fieldTitle = val
    this.temTitle = val
  }
}

RealTimeData._title = '实时数据'
RealTimeData.type = FORM_ITEM__REALTIME_DATA
RealTimeData.use = true
RealTimeData.prototype.icon = 'iconfont icon-shuzi'

RealTimeData.prototype.type = RealTimeData.type
RealTimeData.prototype.dataType = DATA_TYPE__NUMBER

RealTimeData.prototype.filterOpts = [
  {
    name: '等于',
    method: 'eq'
  },
  {
    name: '不等于',
    method: 'ne'
  },
  {
    name: '大于',
    method: 'gt'
  },
  {
    name: '大于等于',
    method: 'gte'
  },
  {
    name: '小于',
    method: 'lt'
  },
  {
    name: '小于等于',
    method: 'lte'
  },
  {
    name: '选择范围',
    method: 'range'
  },
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
RealTimeData.prototype.getValue = function () {
  return this.value
}
RealTimeData.prototype.setValue = function (val) {
  val = val || 0
  this.value = Number(val)
}
RealTimeData.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    defaultValue: this.defaultValue,
    showUnit: this.showUnit
  }
}
RealTimeData.prototype.setConf = function (opts) {
  this.setBase(opts)
  this.showUnit = opts.showUnit ? opts.showUnit : ''
  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
    if (opts.defaultValue.defaultType === DEFAULT_VALUE__CUSTOM) {
      this.value = this.defaultValue.customValue
    }
  }
}
RealTimeData.prototype.valueToString = function (value) {
  value = value || this.value
  return `${value}${this.showUnit}`
}
export default RealTimeData
